import { __assign, __read } from "tslib";
import React, { Fragment, memo, useContext, useState, } from 'react';
import { FieldArray } from 'react-final-form-arrays';
import FieldError from '@mercell/field-error-react';
import stringify from 'fast-safe-stringify';
import { Field } from 'react-final-form';
import { FormContext } from '../utils/FormContext';
import { prepareAndToggleFieldErrors } from '../utils/prepareAndToggleFieldErrors';
import { resolveUseSamePath } from '../utils/resolveUseSamePath';
import { nestedResolveUseSamePath } from '../utils/nestedResolveUseSamePath';
import { nl2br } from '../utils/nl2br';
var updateFieldBasedOnProperties = function (fieldProperties, arrayField, fieldName, fieldValue, previewElementStyle) {
    if (!fieldProperties) {
        return arrayField;
    }
    var updatedArrayField = __assign({}, arrayField);
    if (updatedArrayField.type === 'section') {
        updatedArrayField.isLocked =
            fieldProperties[fieldName] === 'readOnly' ||
                fieldProperties[fieldName] === 'disabled';
        updatedArrayField.readOnlyLock =
            fieldProperties[fieldName] === 'readOnly' || false;
        updatedArrayField.fieldPropertiesFromArrayField = fieldProperties[fieldName];
    }
    else if (fieldProperties[fieldName] === 'readOnly' &&
        updatedArrayField.type !== 'hidden') {
        updatedArrayField.type = 'readOnly';
        if (!arrayField.fieldOrigin) {
            updatedArrayField.fieldOrigin =
                arrayField.type;
        }
        updatedArrayField.readOnlyContent =
            fieldValue[fieldName];
        updatedArrayField.elementProperties = __assign(__assign({}, ((updatedArrayField === null || updatedArrayField === void 0 ? void 0 : updatedArrayField.elementProperties) || {})), { className: previewElementStyle !== null && previewElementStyle !== void 0 ? previewElementStyle : '' });
    }
    else if (fieldProperties[fieldName] === 'disabled' &&
        updatedArrayField.type !== 'hidden') {
        updatedArrayField.type = 'readOnly';
        if (!arrayField.fieldOrigin) {
            updatedArrayField.fieldOrigin = arrayField.type;
        }
        updatedArrayField.disabled = true;
        updatedArrayField.elementProperties = __assign(__assign({}, ((updatedArrayField === null || updatedArrayField === void 0 ? void 0 : updatedArrayField.elementProperties) || {})), { className: previewElementStyle !== null && previewElementStyle !== void 0 ? previewElementStyle : '', disabled: true });
    }
    return updatedArrayField;
};
var generateButton = function (hideButton, action, index, button) {
    if (hideButton || button === undefined) {
        return null;
    }
    return button && button(action, index);
};
export var ArrayField = memo(function (_a) {
    var _b, _c, _d;
    var field = _a.field, name = _a.name, pop = _a.pop, push = _a.push, SchemaElement = _a.SchemaElement;
    var _e = field, _f = _e.fieldWrapperProperties, fieldWrapperProperties = _f === void 0 ? {} : _f, _g = _e.fieldLabel, fieldLabel = _g === void 0 ? function () { return null; } : _g, _h = _e.ariaRequired, ariaRequired = _h === void 0 ? false : _h, validations = _e.validations, arrayFields = _e.arrayFields, internalFieldsWrapper = _e.internalFieldsWrapper, internalFieldsAndLabelWrapper = _e.internalFieldsAndLabelWrapper, _j = _e.arrayFieldLabel, arrayFieldLabel = _j === void 0 ? function () { return null; } : _j, appendButton = _e.appendButton, removeButton = _e.removeButton, _k = _e.defaultAppendValue, defaultAppendValue = _k === void 0 ? function () { return undefined; } : _k, _l = _e.hideAppendButton, hideAppendButton = _l === void 0 ? false : _l, associatedValidationBasedOnOtherFieldValues = _e.associatedValidationBasedOnOtherFieldValues, arrayOfFieldsToRevalidateOnChange = _e.arrayOfFieldsToRevalidateOnChange, _m = _e.partialFieldProps, partialFieldProps = _m === void 0 ? {} : _m, errorsWrapperProperties = _e.errorsWrapperProperties;
    var _o = useContext(FormContext), validationCallback = _o.validationCallback, showErrorsOnInitialRender = _o.showErrorsOnInitialRender, previewElementStyle = _o.previewElementStyle;
    var validateMethod = function () { return null; };
    var _p = __read(useState(false), 2), reApplyRequiredIndicator = _p[0], setReApplyRequiredIndicator = _p[1];
    var updatedConditions = nestedResolveUseSamePath((_c = (_b = associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.conditionalFields) === null || _b === void 0 ? void 0 : _b.conditions) !== null && _c !== void 0 ? _c : [], name);
    var updatedAssociatedValidationBasedOnOtherFieldValues = {
        logicalOperator: (_d = associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.conditionalFields) === null || _d === void 0 ? void 0 : _d.logicalOperator,
        conditions: updatedConditions,
    };
    if ((validations || associatedValidationBasedOnOtherFieldValues) &&
        validationCallback) {
        validateMethod = function (fieldValue, allValues) {
            return validationCallback(fieldValue, validations, allValues, {
                conditionalFields: updatedAssociatedValidationBasedOnOtherFieldValues,
                rules: associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.rules,
                message: associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.message,
                reApplyRequiredIndicator: associatedValidationBasedOnOtherFieldValues === null || associatedValidationBasedOnOtherFieldValues === void 0 ? void 0 : associatedValidationBasedOnOtherFieldValues.reApplyRequiredIndicator,
            }, setReApplyRequiredIndicator);
        };
    }
    var validateFields = arrayOfFieldsToRevalidateOnChange === null || arrayOfFieldsToRevalidateOnChange === void 0 ? void 0 : arrayOfFieldsToRevalidateOnChange.map(function (fieldToRevalidate) {
        if (fieldToRevalidate.useSamePath) {
            return resolveUseSamePath(name, fieldToRevalidate.fieldName);
        }
        return fieldToRevalidate.fieldName;
    });
    var _q = partialFieldProps.parse, parse = _q === void 0 ? function (val) { return val; } : _q;
    return (React.createElement(Field, { name: name, validate: validateMethod, validateFields: validateFields, parse: parse }, function () { return (React.createElement(FieldArray, __assign({}, partialFieldProps, { name: name, data: field }), function (_a) {
        var fields = _a.fields, meta = _a.meta;
        var _b = prepareAndToggleFieldErrors(meta, showErrorsOnInitialRender), showErrors = _b.showErrors, errors = _b.errors;
        return (React.createElement("div", __assign({}, fieldWrapperProperties, { "aria-required": ariaRequired, "data-field": name }),
            fieldLabel(name, reApplyRequiredIndicator),
            fields.map(function (arrayFieldsName, ix) {
                var _a;
                var fieldValue = fields.value[ix];
                var fieldProperties = (_a = fields.value[ix]) === null || _a === void 0 ? void 0 : _a._properties;
                var _b = (fieldProperties || {}).hideRemoveButton, hideRemoveButton = _b === void 0 ? false : _b;
                return (React.createElement("div", __assign({}, internalFieldsAndLabelWrapper, { key: arrayFieldsName }),
                    arrayFieldLabel(ix + 1, arrayFieldsName, hideRemoveButton, function () { return fields.remove(ix); }),
                    React.createElement("div", __assign({}, internalFieldsWrapper),
                        Object.entries(arrayFields).map(function (entry) {
                            var _a = __read(entry, 2), fieldName = _a[0], fieldInArray = _a[1];
                            var updatedFieldInArray = updateFieldBasedOnProperties(fieldProperties, fieldInArray, fieldName, fieldValue, previewElementStyle);
                            return (React.createElement(Fragment, { key: "".concat(fieldName, "_").concat(ix + 1) },
                                React.createElement(SchemaElement, { field: updatedFieldInArray, fieldName: "".concat(arrayFieldsName, ".").concat(fieldName), pop: pop, push: push })));
                        }),
                        generateButton(hideRemoveButton, function () { return fields.remove(ix); }, ix + 1, removeButton))));
            }),
            generateButton(hideAppendButton, function () { return push(name, defaultAppendValue()); }, fields.length ? fields.length + 1 : 1, appendButton),
            showErrors && (React.createElement(FieldError, __assign({}, errorsWrapperProperties), nl2br(errors)))));
    })); }));
}, function (prevProps, nextProps) {
    try {
        return stringify(prevProps) === stringify(nextProps);
    }
    catch (e) {
        console.warn("ArrayField: ".concat(e));
        return false;
    }
});
ArrayField.displayName = 'ArrayField';
